<template>
    <div>
        <app-tabela
            :itens="contrato.penalidades"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="valorMulta" slot-scope="data">
                <p class="text-right m-0">{{ data.valorMulta | currency }}</p>
            </template>
        </app-tabela>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'tipoPenalidade',
                    label: 'Tipo da Penalidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataPenalidade',
                    label: 'Data da Penalidade',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'valorMulta',
                    label: 'Valor da Multa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'recurso',
                    label: 'Recurso',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Última Atualização',
                    sortable: true,
                    type: 'datetime'
                }
            ],
            itensPorPagina: 5
        }
    }
}
</script>
